import { createSlice } from '@reduxjs/toolkit';
import { PaletteOptions } from '@mui/material';
import { RootState } from '../index';

import {
  setAppThemeModeToLocalStorage,
  getAppThemeModeFromLocalStorage,
  setAdminPortalEditModeValueToLocalStorage,
  getAdminPortalEditModeValueFromLocalStorage,
  getTutorEditModeFromLocalStorage,
  setTutorEditModeToLocalStorage,
  getAuthUserFromLocalStorage,
  checkUserRolePermissionOnly,
} from '../../helper';
import { USER_PERMISSION } from '../V2/RolesSlice';

export type TTheme = PaletteOptions['mode'];

export interface IConfigState {
  themeMode: TTheme;
  status: 'idle' | 'loading';
  adminEditMode: boolean;
  tutorEditMode: boolean;
  tutorHomeworkMode: boolean;
}

// THIS FUNCTION IS FOR THE GROUP CLASSES. IMPROVE THIS LATER FOR OTHER MODULES
const getAdminEditMode = () => {
  let res = false;

  const editMode =
    getAdminPortalEditModeValueFromLocalStorage() === 'true' || false;

  const authUser = getAuthUserFromLocalStorage();

  if (editMode && authUser) {
    res = checkUserRolePermissionOnly({
      authUser,
      permissions: {
        adminCourse: USER_PERMISSION.ADMIN_COURSE,
        adminClass: USER_PERMISSION.ADMIN_CLASS,
      },
    });
  }
  return res;
};

const initialState: IConfigState = {
  themeMode: getAppThemeModeFromLocalStorage(),
  status: 'idle',
  adminEditMode: getAdminEditMode(),
  tutorEditMode: getTutorEditModeFromLocalStorage(),
  tutorHomeworkMode: false,
};

export const ConfigSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      const newTheme: TTheme = state.themeMode === 'light' ? 'dark' : 'light';
      state.themeMode = newTheme;
      setAppThemeModeToLocalStorage(newTheme);
    },
    toggleAdminEditModel: (state) => {
      const value = !state.adminEditMode;

      state.adminEditMode = !state.adminEditMode;

      setAdminPortalEditModeValueToLocalStorage(value ? 'true' : 'false');
    },
    toggleTutorEditMode: (state) => {
      const newValue = !state.tutorEditMode;
      state.tutorEditMode = newValue;
      setTutorEditModeToLocalStorage(newValue);
    },
    toggleHomeworkModel: (state) => {
      state.tutorHomeworkMode = !state.tutorHomeworkMode;
    },
  },
});

export const {
  toggleTheme,
  toggleAdminEditModel,
  toggleTutorEditMode,
  toggleHomeworkModel,
} = ConfigSlice.actions;

export const getThemeMode = (state: RootState): TTheme =>
  state.config.themeMode;

export const getConfigState = (state: RootState): RootState['config'] =>
  state.config;

export default ConfigSlice.reducer;
